<template>
        <div class="wrapper" ref="wrapper">
            <ul  ref="content" class="flex-center" style="margin: 0;transform: translateX(0px) translateY(0px) translateZ(1px);" >


                <div class=" vr-fff1 " v-for="(item,i) in vrInfo" :key="i" @click="$router.push({path: '/vrinfo' ,query: { data: item.id}})">
                    <div class="grid-body1" >
                        <div class="grid-content1">
                            <img class="g-c-img1" :src="item.coverList[0]"/>
                        </div>
                        <div class="grid-info1">
                            <li class="title-before1" style="text-align: start">{{item.name}}</li>
                            <li class="title-before">项目编号：{{item.numberNo}}</li>
                            <li class="title-before">项目地址：{{item.address}}</li>
                            <li class="title-before"><span class="see cuIcon-attentionfill ">{{item.views}}</span>
                            </li>
                        </div>
                    </div>
                </div>

            </ul>
        </div>
</template>

<script>
    import BScroll from 'better-scroll'
    export default {
        name: "vr-scroll",
        props: {
            vrInfo: {
                type: Array,
                default: []
            },
        },
        data() {
            const vrItem={
                coverList:['http://browser9.qhimg.com/bdm/480_296_0/t01cd97ec806b712059.jpg'],
                name:'望谟县大观镇伏开村全景图',
                numberNo:'GYNJS234234',
                address:'贵州省黔西南州望谟县大关乡上伏开村一组',
                views:'255',
            }
            return {
                // vrInfo:Array(15).fill(vrItem),
            }
        },
        created(){

        },
        mounted() {
            // console.log('数据长度',this.vrInfo.length)
            // 定时500毫秒执行数据长度检查，
            var vrDataTime = setInterval(()=>{
                if(this.vrInfo.length >0){
                    clearInterval(vrDataTime)
                    this.bscrollInt()
                    // eslint-disable-next-line no-undef
                }
            },500)
        },
        methods: {
            // 初始化scroll。计算滑动宽度
            bscrollInt() {
                // 给内层盒子设置宽度，不设置宽度的话无法滚动
                // 数组长度乘60给style的width
                // let width = this.vrInfo.length * (75)
                console.log('数据长度',this.vrInfo.length)
                let width = this.vrInfo.length * (240)
                console.log('计算宽度',width)
                this.$refs.content.style.width = width + 'px'
                this.$nextTick(() => {
                    console.log('Scroll组件',this.Scroll)
                    if (!this.Scroll) {
                        this.Scroll = new BScroll(this.$refs.wrapper, {
                            click: true,      // 配置允许点击事件
                            scrollX: true,    // 开启横向滚动
                            eventPassthrough: 'vertical',  // 当设置 eventPassthrough 为 'vertical' 的时候，scrollY 无效
                            // movable: true,
                            bounce: true,
                            // zoom: true,
                            // startX: 55,
                            // snapLoop:true
                        })

                    } else {
                        this.Scroll.refresh()     // 重新计算 better-scroll，当 DOM 结构发生变化的时确保滚动效果正常
                    }
                })
            }
        },
    }
</script>

<style scoped>
    li {
        list-style-type: none;
    }
    .flex-center{
        display: flex;
        /*justify-content: center;*/
        /*background-color: antiquewhite;*/
    }
    .wrapper {
        /*background-color: red;*/
        overflow: hidden;
    }
    /*    */
    li{
        list-style: none;
    }
    .vr-fff1{
        /*max-width: 1205px;*/
        /*flex-wrap: nowrap;*/
        display: flex;
        position: relative;
        left: -35px;
    }

    .grid-body1 {

        overflow: hidden;
        max-width: 224px;
        padding-right: 4.5px;
        /*padding-left: 8.5px;*/
        /*height: 312px;*/
        margin-bottom: 10px;
        display: flex;
        flex-wrap: wrap;
    }

    .grid-content1 {
        border-radius: 4px;
        overflow: hidden;
        width: inherit;
        height: 224px;
    }

    .grid-info1 {
        background-color: rgba(255, 255, 255, 1);
        transition: all 0.6s;
        overflow: hidden;
        position: relative;
        bottom: 0;
        border-radius: 0 0 5px 5px;
        width: 100%;
        padding-top: 5px;
    }

    .grid-body:hover .grid-content > img {
        transform: scale(1.2);
    }

    .grid-body:hover .grid-info {
        bottom: 30px;
    }

    .g-c-img1 {
        transition: all 0.6s;
        filter: blur(0px);
        /*width: inherit;*/
        width: 100%;
        height: 100%;
        position: relative;
        background-size: 100% 100%;
        transform: scale(1.04); /*解决不满高度*/
    }

    .title-before {
        text-align: left;
        font-family: 'PingFangSC-Regular', 'PingFang SC', sans-serif;
        font-weight: 400;
        font-style: normal;
        font-size: 12px;
        color: rgba(60, 60, 67, 0.6);
        padding-top: 5px;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
    }

    .title-before:nth-child(1) {
        font-weight: 600;
        font-size: 14px;
        color: #000;
    }
    .see{
        padding-right:15px;
    }
    .praise::before{
        padding: 2px;
    }
    .see::before{
        padding: 2px;
    }

    @media only screen and (max-width: 767px) {
        .grid-content1{
            height: 168px;
        }
    }
</style>